import React from "react";
import styled from "styled-components";
import CreateDocumentFormField from ".";
import useGetDecisionManagersQuery from "features/user/hooks/queries/useGetDecisionManagersQuery";
import { Controller, useFormContext } from "react-hook-form";
import {
  DECISION_MANAGER_FIELD_NAME,
  SUPERADMIN_UUID,
} from "config/documentConstant";
import SearchableSelect from "components/foundation/SearchableSelect/SearchableSelect";

const DecisionManagerField = () => {
  const { control } = useFormContext();

  const { data: decisionManagers } = useGetDecisionManagersQuery({});
  const list = decisionManagers
    ?.filter((item) => item.uuid !== SUPERADMIN_UUID)
    .map((item) => ({
      label: item.name,
      value: item.uuid,
    }));

  return (
    <CreateDocumentFormField label="전결권자지정">
      <Controller
        name={DECISION_MANAGER_FIELD_NAME}
        control={control}
        render={({ field }) => (
          <SelectStyle
            placeholder="선택하세요."
            list={list}
            onValueChange={(value) => {
              field.onChange(value);
            }}
          />
        )}
      />
    </CreateDocumentFormField>
  );
};

export default DecisionManagerField;

const SelectStyle = styled(SearchableSelect)`
  width: 100%;
`;
